import { css, useTheme } from '@emotion/react'
import styled from '@emotion/styled'
import { media } from '@dfds-ui/theme'

const Container = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`

const StripeLeft = styled.svg`
  position: absolute;
  left: 0;
  top: 0;
`

const StripeRight = styled.svg`
  position: absolute;
  right: 0;
  bottom: 0;
`

const StopColor = styled.stop`
  stop-color: ${(props) => props.theme['color-shafts']};
  fill: ${(props) => props.theme['color-shafts']};
`

const StripesMobile = () => {
  return (
    <Container
      css={css`
        display: block;

        ${media.greaterThan('m')`
          display: none;
        `}
      `}
    >
      <StripeLeft
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 174 190"
        css={css`
          max-width: 174px;
        `}
      >
        <defs>
          <linearGradient
            x1="50%"
            y1="-0.00328644669%"
            x2="50%"
            y2="206.753134%"
            id="linearGradient-left-1"
          >
            <StopColor stopColor="#C3E0F4" stopOpacity="0.7" offset="0%" />
            <StopColor stopColor="#C3E0F4" stopOpacity="0" offset="100%" />
          </linearGradient>
          <linearGradient
            x1="117.163015%"
            y1="50%"
            x2="-58.2493394%"
            y2="50%"
            id="linearGradient-left-2"
          >
            <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%" />
            <stop stopColor="#FFFFFF" stopOpacity="0" offset="100%" />
          </linearGradient>
          <linearGradient
            x1="100%"
            y1="50%"
            x2="-42.9617079%"
            y2="50%"
            id="linearGradient-left-3"
          >
            <stop stopColor="#FFFFFF" offset="0%" />
            <stop stopColor="#FFFFFF" stopOpacity="0" offset="100%" />
          </linearGradient>
          <linearGradient
            x1="100%"
            y1="50.0016448%"
            x2="0%"
            y2="50.0016448%"
            id="linearGradient-left-4"
          >
            <stop stopColor="#FFFFFF" stopOpacity="0.3" offset="0%" />
            <stop stopColor="#FFFFFF" stopOpacity="0" offset="100%" />
          </linearGradient>
        </defs>
        <g
          id="phone/Left-Shaft"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <polygon
            id="Rectangle-3"
            fill="url(#linearGradient-left-1)"
            points="-1.00974196e-28 0 52 0 -1.00974196e-28 89.8635918"
          />
          <polygon
            fill="url(#linearGradient-left-2)"
            fillRule="nonzero"
            points="104 0 -1.42108547e-13 175.152711 -1.42108547e-13 50.2020208 29.8279978 0"
          />
          <polygon
            fill="url(#linearGradient-left-3)"
            fillRule="nonzero"
            opacity="0.1"
            points="173.581554 0 60.5979817 189.990364 -4.54747351e-13 189.990364 0 166.731295 99.2760067 0"
          />
          <polygon
            fill="url(#linearGradient-left-4)"
            fillRule="nonzero"
            points="79.9926756 1.66994034e-14 1.6707759e-15 134.896878 0 118.991854 69.9682017 0.983162764 70.5514153 -3.19744231e-14"
          />
        </g>
      </StripeLeft>
      <StripeRight
        xmlns="http://www.w3.org/2000/svg"
        width="152"
        height="190"
        viewBox="0 0 152 190"
        css={css`
          width: 152px;
          height: 190px;
        `}
      >
        <defs>
          <linearGradient
            x1="50%"
            y1="-88.8291991%"
            x2="50%"
            y2="254.776195%"
            id="linearGradient-right-1"
          >
            <StopColor stopColor="#C3E0F4" stopOpacity="0.7" offset="0%" />
            <StopColor stopColor="#C3E0F4" stopOpacity="0" offset="100%" />
          </linearGradient>
          <linearGradient
            x1="127.822819%"
            y1="50%"
            x2="-13.7465658%"
            y2="50%"
            id="linearGradient-right-2"
          >
            <StopColor stopColor="#C3E0F4" stopOpacity="0.4" offset="0%" />
            <StopColor stopColor="#C3E0F4" stopOpacity="0" offset="100%" />
          </linearGradient>
          <linearGradient
            x1="100%"
            y1="50.0016448%"
            x2="-18.8206412%"
            y2="50.0016448%"
            id="linearGradient-right-3"
          >
            <stop stopColor="#FFFFFF" offset="0%" />
            <stop stopColor="#FFFFFF" stopOpacity="0" offset="100%" />
          </linearGradient>
          <linearGradient
            x1="100%"
            y1="50%"
            x2="-3.90126561%"
            y2="50%"
            id="linearGradient-right-4"
          >
            <stop stopColor="#FFFFFF" stopOpacity="0.3" offset="0%" />
            <stop stopColor="#FFFFFF" stopOpacity="0" offset="100%" />
          </linearGradient>
        </defs>
        <g
          id="phone/Right-Shaft"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <polygon
            fill="url(#linearGradient-right-1)"
            fillRule="nonzero"
            points="118.651445 190 152 132.095416 152 190"
          />
          <polygon
            fill="url(#linearGradient-right-2)"
            fillRule="nonzero"
            points="68.763965 190 152 49.8087616 152 174.612653 142.935967 190"
          />
          <polygon
            fill="url(#linearGradient-right-3)"
            fillRule="nonzero"
            opacity="0.1"
            points="0.838167846 190 113.547372 0 152 0 152 60.0489119 75.1099976 190"
          />
          <polygon
            fill="url(#linearGradient-right-4)"
            fillRule="nonzero"
            points="91.5509239 190 152 87.5705443 152 103.445907 100.962886 190"
          />
        </g>
      </StripeRight>
    </Container>
  )
}

const StripesTablet = () => {
  return (
    <Container
      css={css`
        display: none;

        ${media.greaterThan('m')`
          display: block;
        `}

        ${media.greaterThan('l')`
          display: none;
        `}
      `}
    >
      <StripeLeft
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 205 345"
        css={css`
          max-width: 205px;
        `}
      >
        <defs>
          <linearGradient
            id="left-shaft-a"
            x1="50%"
            x2="50%"
            y1="-.003%"
            y2="206.753%"
          >
            <StopColor offset="0%" stopColor="#C3E0F4" stopOpacity=".7" />
            <StopColor offset="100%" stopColor="#C3E0F4" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="left-shaft-b"
            x1="117.163%"
            x2="-58.249%"
            y1="50%"
            y2="50%"
          >
            <stop offset="0%" stopColor="#FFF" stopOpacity=".5" />
            <stop offset="100%" stopColor="#FFF" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="left-shaft-c"
            x1="100%"
            x2="-42.962%"
            y1="50%"
            y2="50%"
          >
            <stop offset="0%" stopColor="#FFF" />
            <stop offset="100%" stopColor="#FFF" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="left-shaft-d"
            x1="100%"
            x2="0%"
            y1="50.002%"
            y2="50.002%"
          >
            <stop offset="0%" stopColor="#FFF" stopOpacity=".3" />
            <stop offset="100%" stopColor="#FFF" stopOpacity="0" />
          </linearGradient>
        </defs>
        <g fill="none" fillRule="evenodd">
          <polygon fill="url(#left-shaft-a)" points="0 0 52 0 0 89.864" />
          <polygon
            fill="url(#left-shaft-b)"
            fillRule="nonzero"
            points="104 0 0 175.153 0 50.202 29.828 0"
          />
          <polygon
            fill="url(#left-shaft-c)"
            fillRule="nonzero"
            points="173.582 0 0 291.869 0 166.731 99.276 0"
            opacity=".1"
          />
          <polygon
            fill="url(#left-shaft-d)"
            fillRule="nonzero"
            points="79.993 0 0 134.897 0 118.992 69.968 .983 70.551 0"
          />
        </g>
      </StripeLeft>
      <StripeRight
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 152 256"
        css={css`
          width: 156px;
          height: 256px;
        `}
      >
        <defs>
          <linearGradient
            id="right-shaft-a"
            x1="50%"
            x2="50%"
            y1="-88.829%"
            y2="254.776%"
          >
            <StopColor offset="0%" stopColor="#C3E0F4" stopOpacity=".7" />
            <StopColor offset="100%" stopColor="#C3E0F4" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="right-shaft-b"
            x1="127.823%"
            x2="-13.747%"
            y1="50%"
            y2="50%"
          >
            <StopColor offset="0%" stopColor="#C3E0F4" stopOpacity=".4" />
            <StopColor offset="100%" stopColor="#C3E0F4" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="right-shaft-c"
            x1="100%"
            x2="-18.821%"
            y1="50.002%"
            y2="50.002%"
          >
            <stop offset="0%" stopColor="#FFF" />
            <stop offset="100%" stopColor="#FFF" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="right-shaft-d"
            x1="100%"
            x2="-3.901%"
            y1="50%"
            y2="50%"
          >
            <stop offset="0%" stopColor="#FFF" stopOpacity=".3" />
            <stop offset="100%" stopColor="#FFF" stopOpacity="0" />
          </linearGradient>
        </defs>
        <g fill="none" fillRule="evenodd">
          <polygon
            fill="url(#right-shaft-a)"
            fillRule="nonzero"
            points="118.651 256 152 198.095 152 256"
          />
          <polygon
            fill="url(#right-shaft-b)"
            fillRule="nonzero"
            points="68.764 256 152 115.809 152 240.613 142.936 256"
          />
          <polygon
            fill="url(#right-shaft-c)"
            fillRule="nonzero"
            points=".838 256 152 .635 152 126.049 75.11 256"
            opacity=".1"
          />
          <polygon
            fill="url(#right-shaft-d)"
            fillRule="nonzero"
            points="91.551 256 152 153.571 152 169.446 100.963 256"
          />
        </g>
      </StripeRight>
    </Container>
  )
}

const StripesDesktop = () => {
  const themeContext = useTheme()

  const useColor = {
    stopColor: themeContext['color-shafts'],
    fill: themeContext['color-shafts'],
  }

  return (
    <Container
      css={css`
        display: none;

        ${media.greaterThan('l')`
          display: block;
        `}
      `}
    >
      <StripeLeft
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 809 603"
        css={css`
          max-width: 809px;
        `}
      >
        <defs>
          <linearGradient
            id="leftShaftGradA"
            x1="50%"
            x2="50%"
            y1="0%"
            y2="100%"
          >
            <StopColor offset="0%" stopColor="#C3E0F4" stopOpacity=".7" />
            <StopColor offset="100%" stopColor="#C3E0F4" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="leftShaftGradB"
            x1="100%"
            x2="24.236%"
            y1="50%"
            y2="50%"
          >
            <stop offset="0%" stopColor="#FFF" stopOpacity=".5" />
            <stop offset="100%" stopColor="#FFF" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="leftShaftGradC"
            x1="100%"
            x2="0%"
            y1="50%"
            y2="50%"
          >
            <stop offset="0%" stopColor="#FFF" />
            <stop offset="100%" stopColor="#FFF" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="leftShaftGradD"
            x1="100%"
            x2="0%"
            y1="50.002%"
            y2="50.002%"
          >
            <stop offset="0%" stopColor="#FFF" stopOpacity=".3" />
            <stop offset="100%" stopColor="#FFF" stopOpacity="0" />
          </linearGradient>
          <linearGradient id="leftShaftGradE" x1="11.903%" y1="50%" y2="50%">
            <StopColor offset="0%" stopColor="#C3E0F4" />
            <StopColor offset="100%" stopColor="#C3E0F4" stopOpacity=".4" />
          </linearGradient>
          <rect id="leftShaftGradF" width="372" height="603" />
        </defs>
        <g fill="none" fillRule="evenodd">
          <polygon
            fill="url(#leftShaftGradA)"
            fillRule="nonzero"
            points="371 0 687 0 445.084 603 371 603"
          />
          <polygon
            fill="url(#leftShaftGradB)"
            fillRule="nonzero"
            points="664.828 0 739 0 490.172 603 416 603"
          />
          <polygon
            fill="url(#leftShaftGradC)"
            fillRule="nonzero"
            points="734.598 0 809 0 559.402 603 485 603"
            opacity=".1"
          />
          <polygon
            fill="url(#leftShaftGradD)"
            fillRule="nonzero"
            points="705.551 0 715 0 714.373 1.057 466.449 603 457 603 704.968 .983"
          />
          <polygon
            fill="url(#leftShaftGradE)"
            fillRule="nonzero"
            points="371 603 376.5 603 613 0 371 0"
          />
          <rect
            fill={useColor.fill}
            fillRule="nonzero"
            width="372"
            height="603"
          ></rect>
        </g>
      </StripeLeft>
      <StripeRight
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="300"
        height="603"
        viewBox="0 0 300 603"
        css={css`
          width: 300px;
          height: 603px;
        `}
      >
        <defs>
          <rect id="righgtShaftExportA" width="300" height="603" />
          <linearGradient
            id="rightShaftExportB"
            x1="50%"
            x2="50%"
            y1="0%"
            y2="100%"
          >
            <StopColor offset="0%" stopColor="#C3E0F4" stopOpacity=".7" />
            <StopColor offset="100%" stopColor="#C3E0F4" stopOpacity="0" />
          </linearGradient>
          <polygon
            id="rightShaftExportC"
            points="316 604 0 604 241.916 0 316 0"
          />
          <linearGradient
            id="rightShaftExportD"
            x1="100%"
            x2="1.587%"
            y1="50%"
            y2="50%"
          >
            <StopColor offset="0%" stopColor="#C3E0F4" stopOpacity="0" />
            <StopColor offset="100%" stopColor="#C3E0F4" stopOpacity=".4" />
          </linearGradient>
          <polygon
            id="rightShaftExportE"
            points="74.172 603 0 603 248.828 0 323 0"
          />
          <linearGradient
            id="rightShaftExportF"
            x1="100%"
            x2="20.222%"
            y1="50.002%"
            y2="50.002%"
          >
            <stop offset="0%" stopColor="#FFF" />
            <stop offset="100%" stopColor="#FFF" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="rightShaftExportG"
            x1="100%"
            x2="17.098%"
            y1="50%"
            y2="50%"
          >
            <stop offset="0%" stopColor="#FFF" stopOpacity=".3" />
            <stop offset="100%" stopColor="#FFF" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="rightShaftExportH"
            x1="0%"
            x2="50%"
            y1="61.13%"
            y2="61.13%"
          >
            <StopColor offset="0%" stopColor="#C3E0F4" stopOpacity="0" />
            <StopColor offset="100%" stopColor="#C3E0F4" />
          </linearGradient>
          <polygon
            id="rightShaftExportI"
            points="242 0 236.5 0 0 604 242 604"
          />
        </defs>
        <g fill="none" fillRule="evenodd">
          <mask id="rightShaftExportJ" fill="#fff">
            <use xlinkHref="#righgtShaftExportA" />
          </mask>
          <g mask="url(#rightShaftExportJ)">
            <g transform="translate(6 -1)">
              <g transform="translate(121)">
                <use
                  fill="url(#rightShaftExportB)"
                  fillRule="nonzero"
                  xlinkHref="#rightShaftExportC"
                />
              </g>
              <g transform="translate(68 1)">
                <use
                  fill="url(#rightShaftExportD)"
                  fillRule="nonzero"
                  xlinkHref="#rightShaftExportE"
                />
              </g>
              <polygon
                fill="url(#rightShaftExportF)"
                fillRule="nonzero"
                points="74.272 603.986 0 603.986 249.163 0 323.435 0"
                opacity=".1"
              />
              <polygon
                fill="url(#rightShaftExportG)"
                fillRule="nonzero"
                points="100.412 421 91 421 338.602 1 348 1"
              />
              <g transform="translate(195)">
                <use
                  fill="url(#rightShaftExportH)"
                  fillRule="nonzero"
                  xlinkHref="#rightShaftExportI"
                />
              </g>
            </g>
          </g>
        </g>
      </StripeRight>
    </Container>
  )
}

const HeroStripes = () => {
  return (
    <>
      <StripesMobile />
      <StripesTablet />
      <StripesDesktop />
    </>
  )
}

export default HeroStripes
